<template lang="pug">
  main.main
    HeaderHidden
    Header
    Products
    Partner(v-if="isShowPartnerBlock")
    Rappers(v-if="$te('rappers.title')")
    Fighters(v-if="$te('fighters.title')")
    Riders
    News
    Socials
    //Contacts
    Faq
</template>

<script>
import HeaderHidden from '@/components/header/HeaderHidden'
import Header from '@/components/header/Header'
import Products from '@/components/products/Products'
import Riders from '@/components/riders/Riders'
import Fighters from '@/components/fighters/Fighters'
import Socials from '@/components/socials/Socials'
import Rappers from '@/components/rappers/Rappers'
import News from '../components/news/News'
// import Contacts from '@/components/contacts/Contacts'
import Faq from '@/components/faq/Faq'
import Partner from '@/components/partner/Partner.vue'
import { mapState } from 'vuex'

export default {
  name: 'Home',
  components: {
    Partner,
    News,
    HeaderHidden,
    Header,
    Products,
    Rappers,
    Riders,
    Fighters,
    Socials,
    // Contacts,
    Faq
  },
  computed: {
    ...mapState('siteVersions', {
      currentSiteVersion: 'item'
    }),
    isShowPartnerBlock: () => false
  }
}
</script>
